import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { Editor, NgxEditorModule, Toolbar, Validators } from 'ngx-editor';
import { AddInstruction } from 'src/app/shared/addinstruction';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';

@Component({
  selector: 'app-add-instructions-dialogbox',
  templateUrl: './add-instructions-dialogbox.component.html',
  styleUrls: ['./add-instructions-dialogbox.component.scss']
})
export class AddInstructionsDialogboxComponent implements OnInit {
  instructionForm: FormGroup;
  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  categoryArray: any;
  selectedCategory: any;
  constructor(
    public dialogRef: MatDialogRef<AddInstructionsDialogboxComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: FormBuilder,
    private webErrorService: WebErrorService,
    private testService: TestService,
    private notificationService: NotificationService,
    public translate: TranslateService,) {
    this.editor = new Editor();
  }

  ngOnInit() {
    this.instructionForm = new FormGroup({
      itemDisplayName: new FormControl('', [Validators.required()]),
      instruction: new FormControl('', [Validators.maxLength(10000)]),
      itemCategory: new FormControl(''),
    });

    // if(this.data.instructionid) {
    this.testService.getInstruction(this.data)?.subscribe((result) => {
      this.categoryArray = result.data.lstItemCategoryMaster;
      this.selectedCategory = this.categoryArray[0].itemCategoryName;
      const instructionDescription = JSON.parse(result.data.instructiondescription);
      if (instructionDescription != null) {
        this.instructionForm.controls['instruction'].setValue(instructionDescription['description']);
      }
      this.instructionForm.controls['itemDisplayName'].setValue(result.data['itemdisplayname']);
      if (result.data['itemcategoryname'] != null && result.data['itemcategoryname'] != '') {
        this.instructionForm.controls['itemCategory'].setValue(result.data['itemcategoryname']);
      }
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
    // }
  }

  get f() {
    return this.instructionForm.controls;
  }

  onClose() {
    this.dialogRef.close();
  }

  saveInstruction() {
    const addNewInstruction: AddInstruction = {
      itemid: JSON.stringify(this.data.itemId),
      instruction: this.instructionForm.value.instruction == '' ? null : { description: this.instructionForm.value.instruction, mediaURL: [""] },
      itemdisplayname: this.instructionForm.value.itemDisplayName,
      itemcategory: this.instructionForm.value.itemCategory,
      ItemCategoryId: (this.instructionForm.value.itemCategory != '' && this.instructionForm.value.itemCategory != null) ?
        this.categoryArray.find(d => d.itemCategoryName === this.instructionForm.value.itemCategory).itemCategoryid : '',
      instructionid: this.data.instructionid == null ? 0 : this.data.instructionid
    };

    if (this.data.instructionid == null) {
      this.testService.addInstructions(addNewInstruction, this.data.testBankuuId)?.subscribe(resData => {
        this.notificationService.success(resData?.message);
        this.dialogRef.close();
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    } else {
      this.testService.updateInstructions(addNewInstruction, this.data.testBankuuId, this.data.instructionid)?.subscribe((resData) => {
        this.notificationService.success(resData?.message);
        this.dialogRef.close();
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    }
  }

  deleteInstruction() {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('testId.TabItems.settings.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('testId.TabItems.settings.deletePopup.btnYes'),
          cancel: this.translate.instant('testId.TabItems.settings.deletePopup.btnNo')
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.testService.deleteInstruction(this.data.testBankuuId, this.data.instructionid)
          .subscribe((resData) => {
            this.notificationService.success(resData?.message);
            this.dialogRef.close();
          },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });
      }
    });
  }
}

@NgModule({
  declarations: [AddInstructionsDialogboxComponent],
  imports: [CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatDividerModule,
    NgxEditorModule,
    ReactiveFormsModule,
    TranslateModule
  ]
})
class AddInstructionsDialogboxComponentModule { }
